<template>
  <div>
    <!-- //添加修改基本信息 -->
    <a-form :form="form" @submit="handleSubmit" class="form-all">
      <b-row>
        <b-col cols="12" md="12">
          <a-form-item
            :label="
              item.fieldTitle === '获得时间'
                ? '获得时间 (仅能确定月份的证书请选择当月任意一天)'
                : item.fieldTitle
            "
            v-for="(item, index) in formData"
            :key="index"
          >
            <!-- 根据字段类型 -->
            <a-input
              v-if="item.fieldType == 'singletext'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
            />
            <a-input
              v-if="item.fieldType == 'label'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
            />
            <a-input
              v-if="item.fieldType == 'position'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
            />
            <!-- 日期 -->
            <a-date-picker
              v-if="item.fieldType == 'date'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
              style="width:100%"
            />
            <!-- 时间 -->
            <a-time-picker
              v-if="item.fieldType == 'time'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
              style="width:100%"
            />
            <!-- 数字 -->
            <a-input
              style="width:100%"
              v-if="item.fieldType == 'number'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
            />
            <!-- 单选 -->
            <a-radio-group
              v-if="item.fieldType == 'radio'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
            >
              <a-radio-button
                v-for="(items, indexs) in selectChange(item.fieldOptions)"
                :key="indexs"
                :value="items"
                >{{ items }}</a-radio-button
              >
            </a-radio-group>
            <!-- 复选 -->
            <a-checkbox-group
              style="width:100%;text-align:left"
              v-if="item.fieldType == 'checkbox'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
            >
              <a-row>
                <a-col
                  :span="6"
                  v-for="(items, indexs) in selectChange(item.fieldOptions)"
                  :key="indexs"
                >
                  <a-checkbox :value="items">{{ items }}</a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
            <!-- 多行文本 -->
            <a-textarea
              style="width:100%"
              v-if="item.fieldType == 'multitext'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
              :rows="8"
              allowClear
              :minLength="item.charactersMin"
              :maxLength="item.charactersMax"
            />
            <!-- 上传 -->
            <a-upload
              v-if="item.fieldType == 'upload'"
              :placeholder="item.fieldHints"
              :headers="headers"
              v-decorator="[
                [item.id],
                {
                  valuePropName: 'fileList',
                  getValueFromEvent: normFile,
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
              action="/api/fs/files"
              accept="image/png, image/jpeg"
              :before-upload="beforeUpload"
            >
              <a-button> <a-icon type="upload" />上传 </a-button>
            </a-upload>
            <!-- 下拉 -->
            <a-select
              v-if="item.fieldType == 'dropdown'"
              :placeholder="item.fieldHints"
              v-decorator="[
                [item.id],
                {
                  rules: [
                    {
                      required: item.flagRequired,
                      message: `${item.fieldHints}`
                    }
                  ]
                }
              ]"
            >
              <a-select-option
                v-for="(items, indexs) in selectChange(item.fieldOptions)"
                :key="indexs"
                :value="items"
                >{{ items }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </b-col>
        <a-form-item class="form-footer">
          <a-button class="success-button usually-button" html-type="submit"
            >保存</a-button
          >
          <a-button class="disable-button usually-button" @click="goBack"
            >取消</a-button
          >
        </a-form-item>
      </b-row>
    </a-form>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
export default {
  name: "FormContext",
  //专业能力，求职意向使用组件
  data() {
    return {
      headers: {},
      formData: [],
      Formtype: this.$route.query.type || "add",
      formId: this.$route.query.formId || 0,
      form: this.$form.createForm(this, {
        name: "formConetxt"
      })
    };
  },
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  watch: {
    data(newval) {
      if (this.Formtype == "add") {
        this.formData = newval;
      }
      if (this.Formtype == "edit") {
        this.createData();
      }
    }
  },
  mounted() {
    this.createData();
    const user = JSON.parse(localStorage.getItem("token"));
    let header =
      user && user.accessToken
        ? {
            authorization: user.tokenType + " " + user.accessToken
          }
        : {};
    this.headers = header;
  },
  methods: {
    //初始化处理
    createData() {
      if (this.Formtype == "add") {
        if (this.data && this.data.length > 0) {
          this.formData = this.data;
        }
      } else {
        let data = [];
        if (this.data && this.data.length > 0) {
          this.data.map(item => {
            data.push(JSON.parse(item.field));
          });
          this.formData = data;
          if (this.formData && this.formData.length > 0) {
            let obj = {};
            this.data.map(item => {
              if (
                JSON.parse(item.field).fieldType == "checkbox" &&
                item.value != ""
              ) {
                item.value = JSON.parse(JSON.stringify(item.value)).split(",");
              } else if (JSON.parse(item.field).fieldType == "upload") {
                if (item.value == "" || !item.value) {
                  item.value = [];
                } else {
                  item.value = JSON.parse(item.value);
                }
              } else if (JSON.parse(item.field).fieldType == "time") {
                if (item.value !== "") {
                  item.value = this.$moment(item.value);
                } else {
                  item.value = null;
                }
              } else if (JSON.parse(item.field).fieldType == "date") {
                if (item.value !== "") {
                  item.value = this.$moment(item.value);
                } else {
                  item.value = null;
                }
              }
              obj[JSON.parse(item.field).id] = item.value;
            });
            this.$nextTick(() => {
              this.form.setFieldsValue(obj);
            });
          }
        }
      }
    },
    //去除逗号
    selectChange(data) {
      const option = data.split(",");
      return option;
    },
    //判断时间是否为invaild
    isValidDate(date) {
      return date instanceof Date && !isNaN(date.getTime());
    },
    goBack() {
      this.$router.go(-1);
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    handleChange({ file, fileList }) {
      if (file.status !== "uploading") {
        console.log(file, fileList);
      }
    },
    //处理上传图片
    uploadChanges(data) {
      if (data) {
        let ossBucket = data.response.data.files[0].ossBucket;
        let ossPath = data.response.data.files[0].ossPath;
        return `oss://${ossBucket}:${ossPath}`;
      } else {
        return "";
      }
    },
    //处理上传图片
    uploadChange(data) {
      if (data && data.length > 0) {
        let uploadArr = [];
        data.map(item => {
          if (item.lastModified) {
            uploadArr.push({
              uid: item.response.data.files[0].uid || item.uid,
              uuid: item.response.data.files[0].uuid || item.uuid,
              name: item.name,
              status: "done",
              url: this.getImgUrl(this.uploadChanges(item)) || item.url
            });
          } else {
            uploadArr.push({
              uid: item.uid,
              uuid: item.uuid,
              name: item.name,
              status: "done",
              url: item.url
            });
          }
        });
        return JSON.stringify(uploadArr);
      } else {
        return [];
      }
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      const isLt2M = file.size / 1024 / 1024 < 2;

      return new Promise((resolve, reject) => {
        if (!isJpgOrPng) {
          this.$message.error("上传只能是图片 JPG或PNG 格式!");
          reject(false);
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
          reject(false);
        }
        resolve(file);
      });
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let data = {
            formId: this.formId,
            records: []
          };
          if (this.Formtype == "edit") {
            this.formData.map(item => {
              for (let i in values) {
                if (item.id == i) {
                  let fieldValue = values[i];
                  if (item.fieldType == "date") {
                    if (fieldValue) {
                      fieldValue = this.$moment(fieldValue).format(
                        "YYYY-MM-DD"
                      );
                    } else {
                      fieldValue = "";
                    }
                  } else if (item.fieldType == "time") {
                    if (fieldValue) {
                      fieldValue = this.$moment(fieldValue).format("HH:mm:ss");
                    } else {
                      fieldValue = "";
                    }
                  } else if (item.fieldType == "upload") {
                    if (fieldValue && fieldValue.length > 0) {
                      let uploadData = JSON.parse(JSON.stringify(fieldValue));
                      fieldValue = this.uploadChange(uploadData);
                    } else {
                      fieldValue = "";
                    }
                  }
                  if (fieldValue instanceof Array) {
                    fieldValue = JSON.parse(JSON.stringify(fieldValue)).join(
                      ","
                    );
                  }
                  data.records.push({
                    field: item,
                    value: fieldValue || "",
                    fieldId: item.id
                  });
                }
              }
            });
          } else {
            data = {
              formId: this.data[0].formId,
              records: []
            };
            this.data.map(item => {
              for (let i in values) {
                if (item.id == i) {
                  let fieldValue = values[i];
                  if (item.fieldType == "date") {
                    if (fieldValue) {
                      fieldValue = this.$moment(fieldValue).format(
                        "YYYY-MM-DD"
                      );
                    } else {
                      fieldValue = "";
                    }
                  } else if (item.fieldType == "time") {
                    if (fieldValue) {
                      fieldValue = this.$moment(fieldValue).format("HH:mm:ss");
                    } else {
                      fieldValue = "";
                    }
                  } else if (item.fieldType == "upload") {
                    if (fieldValue && fieldValue.length > 0) {
                      let uploadData = JSON.parse(JSON.stringify(fieldValue));
                      fieldValue = this.uploadChange(uploadData);
                    } else {
                      fieldValue = "";
                    }
                  }
                  if (fieldValue instanceof Array) {
                    fieldValue = fieldValue.join(",");
                  }
                  data.records.push({
                    field: item,
                    value: fieldValue || "",
                    fieldId: item.id
                  });
                }
              }
            });
          }

          this.$emit("selectBack", data);
        }
      });
    }
  }
};
</script>
<style scoped></style>
